<img
  src="/assets/iconography/support-documentation/{{ icon }}.svg"
  onload="SVGInject(this)"
  onerror="this.src='/assets/iconography/support-documentation/default.svg'" />
